export default __webpack_public_path__ + "static/media/rewardThumbnail.423d5847.png";